import { AppBundle } from 'api/optimalprint-sdk.d';
import Accordion from 'components/Common/Accordion/Accordion';
import React from 'react';
import { AttributeFilterOptionTemplate, FilterAttributeGroup } from 'store/category/types';
import BlockValueOptions from '../BlockValueOptions/BlockValueOptions';
import CheckBoxOptions from '../CheckBoxOptions/CheckBoxOptions';
import ColorOptions from '../ColorOptions/ColorOptions';
import styles from './AttributeFilter.module.scss';

export interface Props {
  attribute: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters.IFilterItem;
  group: FilterAttributeGroup;
}

const AttributeFilter = ({ attribute, group }: Props) => (
  <div className={styles.attributeFilter}>
    <Accordion title={attribute.name} expanded titleClassName={styles.filterTitle}>
      {attribute.optionTemplate === AttributeFilterOptionTemplate.BlockValueOption && (
        <BlockValueOptions attribute={attribute} group={group} />
      )}
      {attribute.optionTemplate === AttributeFilterOptionTemplate.CheckBoxOption && (
        <CheckBoxOptions attribute={attribute} group={group} />
      )}
      {attribute.optionTemplate === AttributeFilterOptionTemplate.ColorOption && (
        <ColorOptions attribute={attribute} group={group} />
      )}
    </Accordion>
  </div>
);

export default AttributeFilter;
